import { useState } from "react";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate=useNavigate();
  const [loading, setLoading] = useState(false); // New state variable for loading state
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmNewPassword) {
        toast.error("Passwords Must Match", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        });
        setFormData({
          ...formData,
          newPassword: '',
          confirmNewPassword: ''
        });
        return;
      }

    try {
    setLoading(true); // Set loading state to true

      const response = await fetch('https://campus-closet-server.vercel.app/api/updatePassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, token })
      });
      if (response.ok) {
        setLoading(false)
        setFormData({
            ...formData,
            newPassword: '',
            confirmNewPassword: ''
          });
        console.log("Password updated successfully");
        toast.success('Password Reset successfully!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000
          });
          setTimeout(() => {
            navigate('/login');
          }, 2000); // Delay of 3000 milliseconds (3 seconds)
      }
      else{
        throw new Error('Failed to update password');
      }
    } catch (error) {
        console.log("Error updating your password:", error);
        toast.error('Failed to update password. Please try again later.', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1000,
          });
          setLoading(false)
    }
    finally{
        setLoading(false)
    }
  };

  return (
    <section className="auth-forms flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
      <div className="form w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
            Reset your password
          </h1>
          <form className="space-y-4 md:space-y-6 h-auto" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="newPassword"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                New Password
              </label>
              <input
                type="password"
                name="newPassword"
                id="newPassword"
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                placeholder="Enter your new password"
                required
                value={formData.newPassword}
                onChange={handleChange}
              />
            </div>
            <div>
              <label
                htmlFor="confirmNewPassword"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Confirm New Password
              </label>
              <input
                type="password"
                name="confirmNewPassword"
                id="confirmNewPassword"
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                placeholder="Confirm your new password"
                required
                value={formData.confirmNewPassword}
                onChange={handleChange}
              />
            </div>
            <button
              type="submit"
              className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading? 'loading...':'Reset Password'}
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default ResetPassword;
